import { QueuePriorityEnum } from '../enums';
import { IProject } from './project.repository';
import { ITeam } from './team.repository';

export interface IRefreshQueue {
  _id: string;
  teamId: string | ITeam;

  name: string;
  initialCount: number;
  remainingCount: number;

  createdAt: string;
  updatedAt: string;

  projectId?: string | IProject;
  priority: QueuePriorityEnum;

  failedCount?: number;
  status?: ERefreshQueueStatus;
  processed?: number;
  total?: number;

  //sales navigator props
  salesSearchUrl?: string;
  limit?: number;

  //HCC props
  hccCompanies?: { name: string; linkedinId?: string }[];
  maxLeadsPerCompany?: number;

  // DealSignal
  watchlistId?: string;
}

export enum ERefreshQueueStatus {
  Pending = 'pending',
  InProgress = 'in-progress',
  SalesCompleted = 'sales-completed',
  Completed = 'completed',
  Notified = 'notified'
}
